import { BrowserRouter } from "react-router-dom";
import AppProvider from "src/providers/appProvider";
import AppRoutes from "./appRoutes";

const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <AppProvider>
        <AppRoutes />
      </AppProvider>
    </BrowserRouter>
  );
};

export default AppRouter;
